// Index file for the directory. Don't add anything else here.
import Sidebar from './Sidebar';
export default Sidebar;
